import React, { useEffect, useRef, useState } from "react";
import { useJsApiLoader, StandaloneSearchBox } from "@react-google-maps/api";
import {
  CFormInput,
  CFormLabel,
  CInputGroup,
  CInputGroupText,
} from "@coreui/react";
import { addressFormatter } from "../../utils/commonFunctions";
import CIcon from "@coreui/icons-react";
import { cilSearch } from "@coreui/icons";
import { FcGoogle } from "react-icons/fc";
import { ERROR_TOAST } from "../../utils/showToast";
/**
 * @function GoogleAutComplete
 * @description for GoogleAutComplete
 * @returns JSX for GoogleAutComplete
 */

const GoogleAutComplete = ({ addressHandler }) => {
  const inputRef = useRef(null);
  const [manualInput, setManualInput] = useState("");

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    libraries: ["places"],
  });

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `.pac-container { z-index: 20000 !important; }`;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handleOnPlaceChanged = () => {
    let address = inputRef.current.getPlaces();
    if (address) {
      addressHandler(addressFormatter(address[0]));
    }
  };

  const parseLatLng = (input) => {
    // Regex to match both "lat,lng" and "25.2048° N, 55.2708° E" formats
    const regex =
      /^\s*(-?\d+(\.\d+)?)[°\s]*([NnSs])?,?\s*(-?\d+(\.\d+)?)[°\s]*([EeWw])?\s*$/;
    const match = input.match(regex);

    if (!match) return null;

    let lat = parseFloat(match[1]);
    let latDir = match[3]?.toUpperCase();
    let lng = parseFloat(match[4]);
    let lngDir = match[6]?.toUpperCase();

    // Apply hemisphere signs
    if (latDir === "S") lat = -Math.abs(lat);
    if (latDir === "N") lat = Math.abs(lat);
    if (lngDir === "W") lng = -Math.abs(lng);
    if (lngDir === "E") lng = Math.abs(lng);

    return { lat, lng };
  };

  const handleManualSearch = () => {
    const coords = parseLatLng(manualInput);

    if (coords && isLoaded) {
      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode({ location: coords }, (results, status) => {
        if (status === "OK" && results[0]) {
          addressHandler(addressFormatter(results[0]));
        } else {
          ERROR_TOAST("No results found for this latitude/longitude.");
        }
      });
    }
  };

  return (
    <div>
      <CFormLabel className="lable-text">{"Find your site"}</CFormLabel>
      {isLoaded && (
        <StandaloneSearchBox
          onLoad={(ref) => (inputRef.current = ref)}
          onPlacesChanged={handleOnPlaceChanged}
        >
          <CInputGroup className="mb-1">
            <CInputGroupText>
              <FcGoogle className="google-icon" />
            </CInputGroupText>
            <CFormInput
              type="text"
              placeholder={"Search your site or enter lat,lng"}
              value={manualInput}
              onChange={(e) => setManualInput(e.target.value)}
            />
            <CInputGroupText
              onClick={handleManualSearch}
              style={{ cursor: "pointer" }}
            >
              <CIcon icon={cilSearch} />
            </CInputGroupText>
          </CInputGroup>
        </StandaloneSearchBox>
      )}
    </div>
  );
};

export default GoogleAutComplete;
